(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Omega"), require("_"), require("axios"), require("elvish"));
	else if(typeof define === 'function' && define.amd)
		define(["Omega", "_", "axios", "elvish"], factory);
	else if(typeof exports === 'object')
		exports["b_crm_i18n-app"] = factory(require("Omega"), require("_"), require("axios"), require("elvish"));
	else
		root["b_crm_i18n-app"] = factory(root["Omega"], root["_"], root["axios"], root["elvish"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__98564__, __WEBPACK_EXTERNAL_MODULE__39479__, __WEBPACK_EXTERNAL_MODULE__83300__, __WEBPACK_EXTERNAL_MODULE__61112__) {
return 